import { combineReducers } from 'redux'
import common from './common'
import userInterface from './userInterface'

export default combineReducers({
  common,
  userInterface
})
